var app = angular.module('leonardo');

let FieldGroupService = function(BaseRestService) {
  return new BaseRestService('fields-groups');
};

app.factory('FieldGroupService', ['BaseRestService', FieldGroupService]);
